import "./view.scss";

import { Navigation } from "swiper/modules";
import Swiper from "swiper";

import "swiper/css";

function initSliders() {
  const sliders = document.querySelectorAll(
    ".wp-block-thirtysix-blocks-curated-categories"
  );

  if (sliders && sliders.length > 0) {
    sliders.forEach((slider) => {
      const element = slider.querySelector(".swiper");
      if (!element) return;

      const slides = element.querySelectorAll(".swiper-slide");
      const slideCount = slides.length;

      const sliderNextButton = slider.querySelector(".swiper-button-next");
      const sliderPrevButton = slider.querySelector(".swiper-button-prev");

      const needsNavigation = {
        mobile: slideCount > 1,
        tablet: slideCount > 2,
        desktop: slideCount > 3,
      };

      function updateNavigation() {
        const width = window.innerWidth;
        let showNav = false;

        if (width >= 1024) {
          showNav = needsNavigation.desktop;
        } else if (width >= 768) {
          showNav = needsNavigation.tablet;
        } else {
          showNav = needsNavigation.mobile;
        }

        if (sliderNextButton && sliderPrevButton) {
          sliderNextButton.style.display = showNav ? "flex" : "none";
          sliderPrevButton.style.display = showNav ? "flex" : "none";
        }
      }

      updateNavigation();
      window.addEventListener("resize", updateNavigation);

      new Swiper(element, {
        modules: [Navigation],
        loop: slideCount > 3,
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        navigation: {
          nextEl: sliderNextButton,
          prevEl: sliderPrevButton,
        },
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            centeredSlides: false,
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initSliders();
});
